import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rectangle creams/rectangle orange biscuit.png";
import BiscuitImg from "../../../assets/products/rectangle creams/Rectangle-Orange.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 75,
  },
  {
    grams: 80,
  },
];

export default function OrangeRollProduct() {
  return (
    <>
      <Helmet>
        <title>
          Rectangle Orange Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Rectangle Orange Cream Biscuits — zesty orange-flavored sandwich biscuits with creamy filling. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Rectangle Orange Cream Biscuit, BearBitz Orange Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/rectangle-cream-biscuit/rectangle-orange"
        />
        <meta
          property="og:title"
          content="Rectangle Orange Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled orange sandwich biscuit in rectangle shape with export-ready packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="ORANGE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#EF5608"
        sectionBgColor="#FFDAC8"
        productBgcolor="#FF9D6B"
        tableheadBgcolor="#EF5608"
        tableBgcolor="#FFF1EA"
        footerBgcolor="#EF5608"
      />
    </>
  );
}
